document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.age');
    if (!section) return;

    const stateSelect = section.querySelector('.ageActionState');
    const proceedButton = section.querySelector('.ageActionProceed');
    const exitButton = section.querySelector('.ageActionExit');
    const error = section.querySelector('.ageError');

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
        return null;
    }

    function setCookie(name, value, days) {
        const maxAge = days * 24 * 60 * 60;
        document.cookie =
            `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax; Secure`;
    }

    const savedState = getCookie('user_selected_state');

    if (savedState) {
        redirectChecker(savedState);
        return;
    }

    if (!section.open) {
        section.showModal();
    }

    document.body.classList.add('noScroll');

    proceedButton.addEventListener('click', function () {
        stateSelect.classList.add('active');
    });

    exitButton.addEventListener('click', function () {
        error.classList.add('active');
        stateSelect.classList.remove('active');
        proceedButton.disabled = true;
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && section.open && !getCookie('user_selected_state')) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, true);

    section.addEventListener('cancel', function (event) {
        event.preventDefault();
    });

    section.addEventListener('close', function () {
        if (!getCookie('user_selected_state')) {
            setTimeout(function () {
                if (!section.open) {
                    section.showModal();
                }
            }, 0);
        }
    });

stateSelect.addEventListener('change', function (event) {
const state = event.target.value;

if (!state) return;

console.log('[Age Gate] Selected state:', state);

// Cookie remains the source of truth
setCookie('user_selected_state', state, 30);

console.log('[Age Gate] Cookie after write:', getCookie('user_selected_state'));

// Debug-only localStorage test for Osano investigation
try {
    localStorage.setItem('user_selected_state', state);

    console.log('[Age Gate] localStorage write attempted');
    console.log(
        '[Age Gate] localStorage value after write:',
        localStorage.getItem('user_selected_state')
    );
} catch (error) {
    console.error('[Age Gate] localStorage exception:', error);
}

console.log('[Age Gate] Final storage state:', {
    selectedState: state,
    cookieValue: getCookie('user_selected_state'),
    localStorageValue: (() => {
        try {
            return localStorage.getItem('user_selected_state');
        } catch (e) {
            return 'ERROR';
        }
    })()
});

section.close();
document.body.classList.remove('noScroll');

redirectChecker(state);

});


   // stateSelect.addEventListener('change', function (event) {
    //    const state = event.target.value;

    //    if (!state) return;

    //    setCookie('user_selected_state', state, 30);

    //    console.log('Age gate saved:', {
    //        user_selected_state: getCookie('user_selected_state')
    //    });

    //    section.close();
    //    document.body.classList.remove('noScroll');

    //    redirectChecker(state);
    //});
});